// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3q_XQ","emails":"CreateEditClinics_emails__3mp8P","emailTagLabel":"CreateEditClinics_emailTagLabel__GotTm"};